import admin from '../locales/en-US/admin.json';
import ai from '../locales/en-US/ai.json';
import auth from '../locales/en-US/auth.json';
import canvas from '../locales/en-US/canvas.json';
import common from '../locales/en-US/common.json';
import invites from '../locales/en-US/invites.json';
import members from '../locales/en-US/members.json';
import navigation from '../locales/en-US/navigation.json';
import settings from '../locales/en-US/settings.json';
import trees from '../locales/en-US/trees.json';
import validation from '../locales/en-US/validation.json';

import hiAdmin from '../locales/hi-IN/admin.json';
import hiAi from '../locales/hi-IN/ai.json';
import hiAuth from '../locales/hi-IN/auth.json';
import hiCanvas from '../locales/hi-IN/canvas.json';
import hiCommon from '../locales/hi-IN/common.json';
import hiInvites from '../locales/hi-IN/invites.json';
import hiMembers from '../locales/hi-IN/members.json';
import hiNavigation from '../locales/hi-IN/navigation.json';
import hiSettings from '../locales/hi-IN/settings.json';
import hiTrees from '../locales/hi-IN/trees.json';
import hiValidation from '../locales/hi-IN/validation.json';

import teAdmin from '../locales/te-IN/admin.json';
import teAi from '../locales/te-IN/ai.json';
import teAuth from '../locales/te-IN/auth.json';
import teCanvas from '../locales/te-IN/canvas.json';
import teCommon from '../locales/te-IN/common.json';
import teInvites from '../locales/te-IN/invites.json';
import teMembers from '../locales/te-IN/members.json';
import teNavigation from '../locales/te-IN/navigation.json';
import teSettings from '../locales/te-IN/settings.json';
import teTrees from '../locales/te-IN/trees.json';
import teValidation from '../locales/te-IN/validation.json';

import esAdmin from '../locales/es-419/admin.json';
import esAi from '../locales/es-419/ai.json';
import esAuth from '../locales/es-419/auth.json';
import esCanvas from '../locales/es-419/canvas.json';
import esCommon from '../locales/es-419/common.json';
import esInvites from '../locales/es-419/invites.json';
import esMembers from '../locales/es-419/members.json';
import esNavigation from '../locales/es-419/navigation.json';
import esSettings from '../locales/es-419/settings.json';
import esTrees from '../locales/es-419/trees.json';
import esValidation from '../locales/es-419/validation.json';

import deAdmin from '../locales/de-DE/admin.json';
import deAi from '../locales/de-DE/ai.json';
import deAuth from '../locales/de-DE/auth.json';
import deCanvas from '../locales/de-DE/canvas.json';
import deCommon from '../locales/de-DE/common.json';
import deInvites from '../locales/de-DE/invites.json';
import deMembers from '../locales/de-DE/members.json';
import deNavigation from '../locales/de-DE/navigation.json';
import deSettings from '../locales/de-DE/settings.json';
import deTrees from '../locales/de-DE/trees.json';
import deValidation from '../locales/de-DE/validation.json';

import { SOURCE_LOCALE } from './locales';
import { I18N_NAMESPACES, I18nNamespace } from './namespaces';

export type LocaleNamespaceResource = Record<string, unknown>;

export const SOURCE_LOCALE_NAMESPACE_RESOURCES: Record<I18nNamespace, LocaleNamespaceResource> = {
  admin,
  ai,
  auth,
  canvas,
  common,
  invites,
  members,
  navigation,
  settings,
  trees,
  validation,
};

// FT-269: First-wave locale resource bundles (statically imported for bundle
// splitting simplicity; these are small JSON files so dynamic import is not
// worth the added complexity at v1 scale).
export const HI_IN_NAMESPACE_RESOURCES: Record<I18nNamespace, LocaleNamespaceResource> = {
  admin: hiAdmin,   ai: hiAi,     auth: hiAuth,     canvas: hiCanvas,
  common: hiCommon, invites: hiInvites, members: hiMembers, navigation: hiNavigation,
  settings: hiSettings, trees: hiTrees, validation: hiValidation,
};

export const TE_IN_NAMESPACE_RESOURCES: Record<I18nNamespace, LocaleNamespaceResource> = {
  admin: teAdmin,   ai: teAi,     auth: teAuth,     canvas: teCanvas,
  common: teCommon, invites: teInvites, members: teMembers, navigation: teNavigation,
  settings: teSettings, trees: teTrees, validation: teValidation,
};

export const ES_419_NAMESPACE_RESOURCES: Record<I18nNamespace, LocaleNamespaceResource> = {
  admin: esAdmin,   ai: esAi,     auth: esAuth,     canvas: esCanvas,
  common: esCommon, invites: esInvites, members: esMembers, navigation: esNavigation,
  settings: esSettings, trees: esTrees, validation: esValidation,
};

export const DE_DE_NAMESPACE_RESOURCES: Record<I18nNamespace, LocaleNamespaceResource> = {
  admin: deAdmin,   ai: deAi,     auth: deAuth,     canvas: deCanvas,
  common: deCommon, invites: deInvites, members: deMembers, navigation: deNavigation,
  settings: deSettings, trees: deTrees, validation: deValidation,
};

export const SOURCE_LOCALE_RESOURCES = {
  [SOURCE_LOCALE]: SOURCE_LOCALE_NAMESPACE_RESOURCES,
} as const;

export const buildLocaleNamespaceResourcePath = (locale: string, namespace: I18nNamespace) =>
  `src/locales/${locale}/${namespace}.json`;

export const SOURCE_LOCALE_RESOURCE_PATHS = I18N_NAMESPACES.map((namespace) =>
  buildLocaleNamespaceResourcePath(SOURCE_LOCALE, namespace));


